/**
 * AddressCorrectionReviewPage - Admin page for address correction review
 *
 * SESSION 197: Address Correction Frontend Admin UI
 *
 * Provides UI for reviewing and approving address correction requests from users
 */
import React from 'react';
import { Container, Box } from '@mantine/core';
import { AddressCorrectionReviewSection } from '@/presentation/components/admin/AddressCorrectionReview';

/**
 * AddressCorrectionReviewPage Component
 *
 * Admin page for address correction review workflow
 */
export const AddressCorrectionReviewPage: React.FC = (): React.ReactElement => {
  return (
    <Container size="xl" py="xl">
      <Box>
        <AddressCorrectionReviewSection />
      </Box>
    </Container>
  );
};
